import React from 'react'
import PropTypes from 'prop-types'
import { Col, Container, Row } from 'react-bootstrap'

// !COMPONENTS
import Layout from '@shared/components/layout'
import ChessInterestingReads from '@shared/components/chessComponents/chessIntrestingReads'
import ChessPlayers from '@shared/components/chessComponents/players'
import MyImage from '@shared/components/myImage'
import sPartner from '@assets/images/wpl/sPartner.png'
import sPartnerMweb from '@assets/images/wpl/sPartnerMweb.png'

import queryGraphql from '@shared/components/queryGraphql'
import { GET_SERIES_NEWS_VIDEOS } from '@graphql/series/home.query'
import { handleApiError, parallelCalls } from '@shared-submodule/utils'
import styles from './style.module.scss'
// import GoogleAds from '@shared-submodule/sm-components/googleAds'
// import { googleAddData } from '@shared-submodule/sm-constants/googleAdsData'
import useWindowSize from '@shared/hooks/windowSize'
import WPLHeader from '@shared/components/WPLComponents/WPLHeader'
import WPLInfo from '@shared/components/WPLComponents/WPLInfo'
import WPLTable from '@shared/components/WPLComponents/WPLTable'
import VenueMweb from '@shared/components/WPLComponents/venueMweb'
import BlogsNews from '@shared/components/olympics/blogsNews'
import WPLMatches from '@shared/components/WPLComponents/WPLMatches'
import WPLTimeline from '@shared/components/WPLComponents/WPLTimeline'
import WPLTeamsMweb from '@shared/components/WPLComponents/WPLTeamsMweb'
import { GET_MAJOR_SERIES_DATA } from '@graphql/ipl/champions'
import { GET_SEO_DATA } from '@graphql/article/article.query'
import WPLCaps from '@shared/components/WPLComponents/WPLCaps'
import { GET_PURPLE_ORANGE_CAP } from '@graphql/series/topPlayers.query'
import dynamic from 'next/dynamic'
import { reviveAdData } from '@shared/components/reviveAds/reviveAdData'

const ReviveAds = dynamic(() => import('@shared/components/reviveAds'), { ssr: false })
function WPL({ allData, news, seoData, editorPick, purpleOrangeCap }) {
  const [width] = useWindowSize()

  const data = news?.listSeriesArticlesVideosFront?.oArticles
  const editorPickData = editorPick?.listSeriesArticlesVideosFront?.oArticles

  const info = allData?.data?.getMajorSeriesData?.aInfo
  const venues = allData?.data?.getMajorSeriesData?.aVenues
  const teams = allData?.data?.getMajorSeriesData?.aTeams
  const captainData = allData?.data?.getMajorSeriesData?.aCaptains
  const pointsData = allData?.data?.getMajorSeriesData?.aSeriesStandings
  const fixture = allData?.data?.getMajorSeriesData?.aFixtures

  const { addTop, mobSm, addLeft } = reviveAdData

  return (
    <Layout
      data={{
        oSeo: seoData?.getSeoData
      }}>
      <>
        <WPLHeader />
        <Container>
          <div className="d-flex flex-column pt-4">
            <div className="w-full d-none d-xl-flex justify-content-center ">
              {/* <GoogleAds
                addId={googleAddData?.addTop?.addId}
                divId={googleAddData?.addTop?.divId}
                dimension={googleAddData?.addTop?.dimension}
                slotId={googleAddData?.addTop?.slotId}
                className={'mb-4'}
              /> */}
              <ReviveAds {...addTop} className={'mb-4'}/>
            </div>
            <div className="w-full d-flex d-xl-none justify-content-center mt-3">
              {/* <GoogleAds
                addId={googleAddData?.mobSm?.addId}
                divId={googleAddData?.mobSm?.divId}
                slotId={googleAddData?.mobSm?.slotId}
                dimension={googleAddData?.mobSm?.dimension}
                className={'mb-4'}
              /> */}
              <ReviveAds {...mobSm} className={'mb-4'}/>
            </div>
            <Row className={`${styles.gap} mb-4`}>
              <Col xxl={3} className={`${styles.order} d-xxl-block d-none`}>
                {<WPLInfo info={info} venues={venues} />}
                <div className="w-full d-flex justify-content-center ">
                  {/* <GoogleAds
                    addId={googleAddData?.addLeft?.addId}
                    divId={googleAddData?.addLeft?.divId}
                    dimension={googleAddData?.addLeft?.dimension}
                    slotId={googleAddData?.addLeft?.slotId}
                    className={'mb-4'}
                  /> */}
                  <ReviveAds {...addLeft} className={'mb-4'}/>
                </div>
              </Col>
              <Col xl={8} xxl={6} className={`${styles.centerContent}`}>
                <WPLMatches fixture={fixture} />
              </Col>
              <Col xl={4} xxl={3} className="common-sidebar mt-0">
                <WPLTable points={pointsData} />
                {width > 767 && (
                  <>
                    <h4 className="font-bold">Streaming Partner</h4>
                    <a href="https://www.hotstar.com/" target="blank" className="d-flex my-3 justify-content-center w-100">
                      <MyImage src={sPartner} />
                    </a>
                    <WPLCaps purpleOrangeCap={purpleOrangeCap}/>
                  </>
                )}
              </Col>
            </Row>
            {width < 767 && (
              <>
                <div className="mb-4">
                  <h4 className="font-bold">Venues</h4>
                  <VenueMweb venues={venues} />
                </div>
                <a href="https://www.hotstar.com/" target="blank" className="d-flex justify-content-center w-100">
                  <MyImage src={sPartnerMweb} />
                </a>
                <WPLCaps purpleOrangeCap={purpleOrangeCap}/>
              </>
            )}
            {width > 767 && <ChessInterestingReads data={editorPickData?.aResults} />}
            {<WPLTimeline team={teams} />}
            {width < 767 && (
              <>
                <ChessInterestingReads data={editorPickData?.aResults} />
                <div className="w-full d-flex d-xl-none justify-content-center mt-3">
                  {/* <GoogleAds
                    addId={googleAddData?.mobSm?.addId}
                    divId={'div-gpt-ad-1726652608372-0'}
                    slotId={googleAddData?.mobSm?.slotId}
                    dimension={googleAddData?.mobSm?.dimension}
                    className={'mb-4'}
                  /> */}
                  <ReviveAds {...mobSm} className={'mb-4'}/>
                </div>
                <WPLTeamsMweb team={teams} />
              </>
            )}
            <ChessPlayers isWPL captains={captainData} />
            {data?.aResults && <BlogsNews isWPL data={data?.aResults} />}
            {width < 767 && (
              // <GoogleAds
              //   addId={googleAddData?.mobLg?.addId}
              //   divId={googleAddData?.mobLg?.divId}
              //   dimension={googleAddData?.mobLg?.dimension}
              //   slotId={googleAddData?.mobLg?.slotId}
              //   className={'mt-0 mb-4'}
              // />
              <ReviveAds {...addLeft} className={'mt-0 mb-4'}/>
            )}
          </div>
        </Container>
      </>
    </Layout>
  )
}

export async function getServerSideProps({ res, resolvedUrl }) {
  try {
    res.setHeader('Cache-Control', 'public, max-age=600')

    const seriesId = '6789e3d1365a27d0e1eb1025'
    const [editorPick, news] = await parallelCalls([
      queryGraphql(GET_SERIES_NEWS_VIDEOS, {
        input: {
          nLimit: 4,
          nSkip: 0,
          iSeriesId: seriesId,
          eType: 'n'
        }
      }),
      queryGraphql(GET_SERIES_NEWS_VIDEOS, {
        input: {
          nLimit: 12,
          nSkip: 0,
          iSeriesId: seriesId,
          eType: 'n'
        }
      })
    ])
    const allData = await queryGraphql(GET_MAJOR_SERIES_DATA, {
      input: { iSeriesId: seriesId }
    })
    const purpleOrangeCap = await queryGraphql(GET_PURPLE_ORANGE_CAP, { input: { iSeriesId: seriesId } })
    const { data: seoData } = await queryGraphql(GET_SEO_DATA, { input: { sSlug: 'wpl-womens-indian-premier-league-2025' } })
    return {
      props: {
        news: news || {},
        editorPick: editorPick || {},
        allData: allData || {},
        purpleOrangeCap: purpleOrangeCap || {},
        seoData
      }
    }
  } catch (e) {
    console.error('Error fetching data:', e)
    res.setHeader('Cache-Control', 'no-cache')
    const status = handleApiError(e, resolvedUrl)
    return status
  }
}

WPL.propTypes = {
  news: PropTypes.object,
  editorPick: PropTypes.object,
  seoData: PropTypes.object,
  allData: PropTypes.array,
  info: PropTypes.array,
  venues: PropTypes.array,
  teams: PropTypes.array,
  purpleOrangeCap: PropTypes.object
}

export default WPL
